const Pagination = ({ paginationData, onPageChange }: any) => {
  const { page, hasPrevPage, hasNextPage, pagingCounter } = paginationData;

  return (
    <div className="flex items-center justify-between space-x-4">
      <button
        className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={!hasPrevPage}
        onClick={() => onPageChange(page - 1)}
      >
        ◀
      </button>
      <span className="text-lg font-semibold">{pagingCounter}</span>
      <button
        className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={!hasNextPage}
        onClick={() => onPageChange(page + 1)}
      >
        ▶
      </button>
    </div>
  );
};

export default Pagination;
